<template>
  <div id="app">
    <Nav></Nav>
    <div class="toptit"></div>
    <div class="block">
      <h1><span>供应</span>链</h1>
    </div>
    <div class="supply">
      <div class="system">
        <p class="title"><span>供应链体系</span></p>
        <div class="title-underline"></div>
        <div class="sys-content">
          <div>
            <img src="../assets/system1.png"
                 alt="">
            <p class="sys-con-tit">产品开发打板</p>
            <p>高效的产品控制</p>
          </div>
          <div>
            <img src="../assets/system2.png">
            <p class="sys-con-tit">制定项目采购策略</p>
          </div>
          <div>
            <img src="../assets/system3.png">
            <p class="sys-con-tit">严苛的货物质量检测</p>
          </div>
          <div>
            <img src="../assets/system4.png">
            <p class="sys-con-tit">完整产品生产品质</p>
            <p>科学管理供应链</p>
          </div>
          <div>
            <img src="../assets/system5.png">
            <p class="sys-con-tit">完整的物流体系</p>
            <p>供应商管理</p>
          </div>
        </div>
      </div>
      <div class="strategy">
        <p class="title">采购策略</p>
        <div class="title-underline"></div>
        <div class="str-content">
          <div class="str-con">
            <img src="../assets/purchase1.png">
            <span>三家比价</span>
            <p>三家评估 趋势分析</p>
          </div>
          <div class="str-con">
            <img src="../assets/purchase2.png">
            <span>唯一资源</span>
            <p>客户指定 知识产权</p>
          </div>
          <div class="str-con">
            <img src="../assets/purchase3.png">
            <span>战略合作</span>
            <p>主要品类 都有优质的<br />战略合作伙伴</p>
          </div>
        </div>
      </div>
      <div class="production">
        <p class="title">生产品质控制流程</p>
        <div class="title-underline"></div>
        <!-- <div class="pro">
          <div class="pro-explain">
            <p>设计开发评估</p>
            <p>手办评估</p>
            <p style="line-height: normal;">制定大货质量控制计划<br>
            </p>
            <p>大货产品第三方<br />实验室送检
            </p>
            <p>大货质量过程控制</p>
          </div>
          <div class="pro-img">
            <div class="pro-img-top">
              <span style="margin-left: 14%;">1</span>
              <span style="margin-left: 15%;">2</span>
              <span style="margin-left: 18%;">3</span>
              <span style="margin-left: 20%;">4</span>
            </div>
            <div class="pro-img-right">
              <span>5</span>
            </div>
            <div class="pro-img-bottom">
              <div style="margin: -95px 0 0 -55px;">
                <p>进仓外观检验</p>
                <span>7</span>
              </div>
              <div style="margin: -95px 0 0 400px;">
                <p>大货验收出具验收报告</p>
                <span>6</span>
              </div>
            </div>
          </div>
        </div> -->
        <div class="liucheng">
          <img src="../assets/liucheng.png" alt="">
        </div>
      </div>
      <div class="example">
        <div class="example-tit">
          <h1>制作公司成品范例</h1>
          <div class="example-underline"></div>
        </div>
        <div class="example-img">
          <img src="../assets/example-img.png" alt="">
        </div>
      </div>
      <div class="logistics">
        <p>物流流程</p>
        <div class="logistics-underline"></div>
        <div class="process">
          <img src="../assets/wuliuliucheng.png" alt="">
        </div>
      </div>
    </div>
    <BottomNav></BottomNav>
    <div class="gyl-top">
      <img src="../assets/gongyinglian-top.png" alt="">
    </div>
    <div class="gyl-bottom">
      <img src="../assets/gongyinglian-bottom.png" alt="">
    </div>
  </div>
</template>

  <script>
import Nav from '../components/Nav'
import BottomNav from '../components/BottomNav'
import Vue from 'vue'
import VueAwesomeSwiper from "vue-awesome-swiper";
import "swiper/css/swiper.css";
import Swiper from "swiper";
export default {
  name: 'Business',
  data () {
    return {
    }
  },
  methods: {
  },
  mounted () {
    var swiper = new Swiper("#topSwiper", {
      slidesPerView: 4,
      spaceBetween: 0,
      centeredSlides: true,
      loop: true,
      // autoplay: {
      //   // delay: 2000,
      //   disableOnInteraction: false
      // },
      pagination: {
        el: ".swiper-pagination",
        clickable: true
      }
    });
    window.onscroll = function() {
      var scrollTop =
      document.documentElement.scrollTop || document.body.scrollTop;
      var topNav = document.getElementById("topNav");
      if (scrollTop > 0) {
        topNav.style.width = "100%";
        topNav.style.position = "fixed";
        topNav.style.top = "0";
        topNav.style.left = "0";
        topNav.style.paddingLeft = "33.5%";
        // topNav.style.zIndex = 11;

      } else{
        // topNav.style.paddingLeft = "0%";
        // topNav.style.width = "32.42%";
        // topNav.style.left = "33.5%";
        // topNav.style.zIndex = 9;

      }
      // if (scrollTop = 0) {
      //   topNav.style.width = "29.42%";
      // }
    };
  },
  components: { Nav, BottomNav }
}
  </script>

<style lang="less" scoped>
#app {
  font-family: "微软雅黑";
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  position: relative;
  @media screen and (min-width: 140px) {
    min-width: 1050px;
    margin: 0 auto;
  }
  @media screen and (min-width: 1920px) {
    min-width: 1240px;
    margin: 0 auto;
  }
}
.image {
  width: 100%;
}
.logoImg {
  width: 141px;
  height: 86px;
}
.tit {
  text-align: left;
  h1 {
    color: #fce04f;
    font-size: 61px;
    font-family: Impact;
    font-weight: 400;
    border-bottom: 2px solid #fce04f;
    width: 67px;
  }
  p {
    font-size: 20px;
  }
}
.block {
  background-color: #333333;
  height: 100px;
  display: flex;
  align-items: center;
  h1 {
    color: #ffffff;
    line-height: 100px;
    width: fit-content;
    width: -webkit-fit-content;
    width: -moz-fit-content;
    margin: 0 0 0 35%;
    font-weight: bold;
    @media screen and (min-width: 140px) {
      font-size: 24px;
    }
    @media screen and (min-width: 1920px) {
      font-size: 26px;
    }
    span {
      border-bottom: 4px solid #fce04f;
      padding-bottom: 5px;
    }
  }
}
.gyl-top{
  position: absolute;
  top: 267px;
  z-index: -10;
  img{
    width: 100%;
  }
}
.gyl-bottom{
  position: absolute;
  bottom: 0px;
  width: 80%;
  left: 50%;
  margin-left: -760px;
  z-index: -10;
  img{
    width: 100%;
  }
}
.toptit {
  width: 100%;
  height: 56px;
}
.supply {
  .title {
    margin: 0 0 55px 0;
    font-weight: bold;
    color: rgba(51, 51, 50, 1);
    line-height: 20px;
    @media screen and (min-width: 140px) {
      font-size: 18px;
    }
    @media screen and (min-width: 1920px) {
      font-size: 24px;
    }
  }
  .title-underline {
    margin: -40px auto 28px;
    width: 67px;
    height: 4px;
    background: rgba(252, 224, 79, 1);
    border-radius: 1px;
  }
  .system {
    padding-top: 103px;
    margin: 0 auto;
    width: 65%;
    .sys-content {
      display: flex;
      margin: 55px auto;
      justify-content: space-between;
      img{
        width: 110px;
        height: 93px;
      }
      p {
        text-align: center;
        height: 9px;
        font-size: 16px;
        color: #333;
        line-height: 40px;
        @media screen and (min-width: 140px) {
          font-size: 14px;
        }
        @media screen and (min-width: 1920px) {
          font-size: 16px;
        }
      }
      .sys-con-tit {
        margin: 43px 0 7px 0 !important;
        font-weight: bold;
        color: rgba(51, 51, 51, 1);
        line-height: 25px;
         @media screen and (min-width: 140px) {
          font-size: 16px;
        }
        @media screen and (min-width: 1180px) {
          font-size: 18px;
        }
        @media screen and (min-width: 1920px) {
          font-size: 24px;
        }
      }
    }
  }
  .strategy {
    padding-top: 20px;
    padding-bottom: 100px;
    margin: 0 auto;
    width: 65%;
    .title{
      color: #333;
      font-weight: bold;
      @media screen and (min-width: 140px) {
        font-size: 18px;
      }
      @media screen and (min-width: 1920px) {
        font-size: 24px;
      }
    }
    .str-content {
      width: 100%;
      margin: 0 auto;
      display: flex;
      justify-content: space-between;
      padding-top: 30px;
      .str-con {
        box-sizing: border-box;
        width: 32%;
        background: rgba(252, 224, 79, 1);
        padding: 21px 19px;
        img {
          width: 100%;
        }
        span {
          display: inline-block;
          margin-top: 16px;
          padding: 20px 50px;
          border: 1px solid rgba(102, 102, 102, 1);
          font-weight: bold;
          color: rgba(51, 51, 51, 1);
          line-height: 24px;
          @media screen and (min-width: 140px) {
            font-size: 18px;
          }
          @media screen and (min-width: 1920px) {
            font-size: 24px;
          }
        }
        p {
          color: rgba(51, 51, 51, 1);
          line-height: 24px;
          margin: 13px 0 0 0;
          @media screen and (min-width: 140px) {
            font-size: 14px;
          }
          @media screen and (min-width: 1920px) {
            font-size: 16px;
          }
        }
      }
    }
  }
  .production {
    background: rgba(51, 51, 50, 1);
    padding-top: 58px;
    padding-bottom: 50px;
    .pro {
      margin: 140px 0 0 0;
    }
    .title {
      color: white;
      font-weight: bold;
      @media screen and (min-width: 140px) {
        font-size: 18px;
      }
      @media screen and (min-width: 1920px) {
        font-size: 24px;
      }
    }
    .liucheng{
      width: 70%;
      padding-top: 20px;
      img{
        width: 100%;
      }
    }
    .pro-explain {
      display: flex;
      justify-content: space-between;
      width: 80%;
      margin: 0 auto;
      p {
        font-size: 24px;
        color: rgba(255, 255, 255, 1);
        display: flex;
        align-items: center;
      }
    }
    .pro-img {
      div {
        background: rgba(252, 224, 79, 1);
      }
      span {
        float: left;
        width: 42px;
        height: 42px;
        line-height: 42px;
        background: rgba(252, 224, 79, 1);
        border: 1px solid rgba(51, 51, 50, 1);
        border-radius: 50%;
        font-size: 24px;
      }
      .pro-img-top {
        height: 9px;
        width: 87%;
        span {
          margin-top: -18px;
        }
      }
      .pro-img-right {
        width: 9px;
        height: 339px;
        margin-left: 86.4%;
        span {
          margin: -25px 0 0 -18px;
        }
      }
      .pro-img-bottom {
        margin-left: 31.6vw;
        height: 9px;
        width: 55%;
        div {
          float: left;
          background: none;
          display: flex;
          align-items: center;
          flex-flow: column;
          p {
            color: white;
            font-size: 24px;
            font-weight: bold;
          }
        }
      }
    }
  }
  .example {
    padding-top: 50px;
    margin: 0 auto;
    width: 65%;
    .example-tit {
      h1 {
        font-weight: bold;
        color: rgba(51, 51, 50, 1);
        line-height: 40px;
        margin: 0;
        padding-bottom: 20px;
        @media screen and (min-width: 140px) {
          font-size: 18px;
        }
        @media screen and (min-width: 1920px) {
          font-size: 24px;
        }
      }
      span {
        font-size: 31px;
        color: #333333;
        line-height: 40px;
      }
      div {
        margin: -20px auto 28px;
        width: 67px;
        height: 4px;
        background: rgba(252, 224, 79, 1);
        border-radius: 1px;
      }
    }
    .example-img{
      margin-top: 70px;
      width: 100%;
      img{
        width: 100%;
      }
    }
  }
  .logistics {
    padding-top: 50px;
    margin: 0 auto;
    width: 65%;
    p {
      font-weight: bold;
      color: rgba(51, 51, 50, 1);
      line-height: 40px;
      @media screen and (min-width: 140px) {
        font-size: 18px;
      }
      @media screen and (min-width: 1920px) {
        font-size: 24px;
      }
    }
    .logistics-underline {
      margin: -20px auto 28px;
      width: 67px;
      height: 4px;
      background: rgba(252, 224, 79, 1);
      border-radius: 1px;
    }
    .process{
      padding-top: 50px;
      padding-bottom: 100px;
      width: 100%;
      img{
        width: 100%;
      }
    }
  }
}
#topSwiper {
  width: 65%;
  height: 675px;
  margin-top: 97px;
  // .swiper-wrapper{
  //   margin-left: -150px;
  //   .third-swiper{
  //     margin-left: -50px !important;
  //   }
  // }
  .swiper-wrapper{
    margin-left: -12.3%;;
  }
  // .fourth-swiper{
  //   margin-right: 45px !important;
  // }
  .swiper-slide {
    text-align: center;
    font-size: 18px;
    background: #fff;

    /* Center slide text vertically */
    display: -webkit-box;
    display: -ms-flexbox;
    display: -webkit-flex;
    display: flex;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    -webkit-justify-content: center;
    justify-content: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    -webkit-align-items: center;
    align-items: center;
    transition: 300ms;
    transform: scale(0.9);
    display: flex;
    flex-flow: column;
    img {
      width: 100%;
      display: block;
    }
  }
  .swiper-slide-active,
  .swiper-slide-duplicate-active {
    transform: scale(1);
  }
}
</style>
  <style lang="less">
//   .el-submenu__title:hover{
//   background-color: #fff !important;
// }
.el-submenu__title{
  color: #333 !important;
}
.el-submenu__title a{
  color: #333 !important;
}
</style>
